/**
 * @description API Return Code (enum)
 */
export enum ReturnCodesEnum {
  /** 成功 */
  CodeSuccess = '0000',
  /** 缺少必要參數 */
  CodeRequireParam = '1001',
  /** 參數格式錯誤 */
  CodeParamFormatError = '1002',
  /** 查無資料 */
  CodeNoInfo = '1003',
  /** 初始化參數錯誤 */
  CodeInitPrarmError = '1004',
  /** 輸入資料有誤，請重新選擇或電洽台銀人壽客服中心 */
  CodeDataError = '1007',
  /** 車主出生年月日與保發關貿資料不符 */
  CodeVehicleOwnerBirthdayIncompatible = '1011',
  /** 系統連線異常 */
  CodeConnectionError = '2001',
  /** 資料庫錯誤 */
  CodeDatabaseError = '2002',
  /** 信用卡授權失敗 */
  CodeCreditCardAuthorizationFailure = '2007',
  /** 信用卡取消授權失敗 */
  CodeCreditCardCancelAuthorizationFailure = '2012',
  /** 會員即時檢核功能已關閉 */
  CodeCheckingMobileEmailClosed = '2017',
  /** 非法的 Token */
  CodeIllegalToken = '8003',
  /** 非法的 Token */
  IllegalToken = '8004',
  /** 非法的 Token */
  TokenError8015 = '8015',
  /** 非法的 Token */
  TokenError8016 = '8016',
  /** 非法的 Token */
  TokenError8017 = '8017',
  /** 非法的 Token:token已過期 */
  TokenError8018 = '8018',
  /** keycloak 無回應或回應錯誤 */
  KeycloakError = '8019',
  /** keycloak 驗證失敗 */
  KeycloakValidError = '8020',
  /** 登入驗證錯誤:非有效帳戶 */
  KeycloakValidMemberError = '8021',
  /** 登入驗證錯誤:用戶非啟用狀態 */
  CodeUserNotEnable = '8008',
  /** 未知錯誤 */
  CodeUnknownError = '9999'
}
